var React = require('react');

function IconCommodityGas (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.01578 13.985C9.38305 12.6528 9.81877 11.3656 9.81877 9.21708C9.81877 7.18372 9.12261 5.85652 7.68524 4.65453C7.61011 4.58943 7.49993 4.65954 7.52497 4.75971C8.08089 6.91327 7.67522 9.14196 6.83383 10.4742C6.78374 10.0635 6.32799 8.88153 5.89227 8.29055C5.80713 8.17536 5.62182 8.18037 5.55671 8.31559C5.31632 8.80641 4.69529 9.50757 4.46491 10.404C3.9791 12.3022 5.09595 13.3389 5.65688 14C4.73535 13.9649 1.5 13.0434 1.5 9.80305C1.5 8.24047 2.11602 6.83815 2.67695 5.91662C3.76875 4.10863 5.26623 2.00515 6.01748 0.262266C6.13267 -0.0031736 6.46822 -0.0833062 6.69359 0.0969922C10.8905 3.47759 12.7737 6.10694 12.7737 9.04179C12.7737 13.9349 8.01578 14.02 8.01578 13.985Z"}));
}

IconCommodityGas.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = IconCommodityGas;

IconCommodityGas.default = IconCommodityGas;
